import { fileUrl } from "../../../../services/config";
import { digitsThree } from "../../../../utils/price";

function SingleOrderCard({ data }) {
  return (
    <div className="flex flex-col lg:flex-row items-center py-6 border-b border-gray-200 gap-6 w-full">
      <div className="img-box max-lg:w-full">
        <img
          src={`${fileUrl}files/medium_${data.product?.mainImage}`}
          className="aspect-square w-full lg:max-w-[140px] rounded-xl"
        />
      </div>
      <div className="flex flex-row items-center w-full ">
        <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
          <div className="flex items-center">
            <div className="">
              <h2 className="font-semibold text-xl leading-8 text-black dark:text-white mb-3">
                {data?.productName}
                {data?.isGift ? " - هدیه" : ""}
              </h2>
              <p className="font-normal text-sm leading-8 text-gray-500 dark:text-gray-100 mb-3 ">
                قیمت : {digitsThree(data?.basePrice)}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mt-3 lg:mt-0">
            <div className="text-center p-2 lg:p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p className="font-medium text-xs lg:text-sm text-gray-500 dark:text-gray-300 mb-1">تعداد</p>
              <p className="font-semibold text-sm lg:text-base text-indigo-600">{digitsThree(data?.count)}</p>
            </div>
            <div className="text-center p-2 lg:p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p className="font-medium text-xs lg:text-sm text-gray-500 dark:text-gray-300 mb-1">تخفیف</p>
              <p className="font-semibold text-sm lg:text-base text-emerald-500">{digitsThree(data?.discountPrice)}</p>
            </div>
            <div className="col-span-2 lg:col-span-1 text-center p-2 lg:p-3 bg-indigo-50 dark:bg-indigo-900 rounded-lg">
              <p className="font-medium text-xs lg:text-sm text-gray-500 dark:text-gray-300 mb-1">قیمت نهایی</p>
              <p className="font-bold text-base lg:text-lg text-indigo-600 dark:text-indigo-400">{digitsThree(data?.finalPrice)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleOrderCard;
